import axiosInstance from "./AxiosInstance";

// export function getBranches(pagination, pageid,search_by = "", search_keyword = "",sort_by="",sort_order="") {
//   return axiosInstance.post("/admin/branchList", { pagination, pageid ,search_by,search_keyword,sort_by,sort_order});
// }
export function getBranches(
  pagination = true,
  pageid = 0,
  search_by = "",
  search_keyword = "",
  sort_by = "",
  sort_order = ""
) {
  return axiosInstance.post("/admin/branchList", {
    pagination,
    pageid,
    search_by,
    search_keyword,
    sort_by,
    sort_order
  });
}

export function createBranch(branchData) {
  return axiosInstance.post("/admin/addBranch", branchData);
}

export function updateBranch(branchData) {
  return axiosInstance.post(`/admin/editBranch`, branchData);
}

export function deleteBranch(branch) {
  return axiosInstance.post(`/admin/deleteBranch`, branch);
}

export function formatBranches(responseData) {
  if (!responseData) return [];

  if (Array.isArray(responseData)) {
    return responseData.map((branch) => ({
      ...branch,
      branch_id: branch.branch_id || branch._id || branch.id,
    }));
  }

  let branches = [];
  for (let key in responseData) {
    if (responseData.hasOwnProperty(key)) {
      branches.push({
        ...responseData[key],
        branch_id:
          responseData[key].branch_id ||
          responseData[key]._id ||
          responseData[key].id ||
          key,
      });
    }
  }
  return branches;
}
